import { createReducer } from '@reduxjs/toolkit'
import { cloneDeep } from 'lodash'
import { Ether, Wei } from 'types'
import {
  resertConvertState,
  updateBaseToken,
  updateCurrentConvertInfo,
  updateQuoteToken,
  updateSwapDisabled,
} from './actions'
import { Currency } from 'api/v1/market'

export interface ConvertToken {
  token?: Currency
  amount?: Ether
}
export interface ConvertRange {
  minSize: string
  maxSize: string
}
export interface CurrentConvertInfo {
  baseAmount?: Ether
  quoteAmount?: Ether
  expireTime?: number
  price?: Wei
  baseRange?: ConvertRange
  quoteRange?: ConvertRange
  priceFrom?: Wei
  priceTo?: Wei
  feeRate?: number
}
export interface ConvertState {
  baseToken: ConvertToken
  quoteToken: ConvertToken
  currentConvertInfo: CurrentConvertInfo
  swapDisabled: boolean
}
export const initialState: ConvertState = {
  baseToken: {
    token: undefined,
    amount: '',
  },
  swapDisabled: false,
  quoteToken: {
    token: undefined,
    amount: '',
  },
  currentConvertInfo: {
    baseAmount: '',
    quoteAmount: '',
    price: '',
    feeRate: 0,
    baseRange: {
      minSize: '',
      maxSize: '',
    },
    quoteRange: {
      minSize: '',
      maxSize: '',
    },
    priceFrom: '',
    priceTo: '',
  },
}
export default createReducer<ConvertState>(initialState, (builder) => {
  builder
    .addCase(updateBaseToken, (state, { payload }) => {
      state.baseToken = { ...state.baseToken, ...payload }
    })
    .addCase(updateQuoteToken, (state, { payload }) => {
      state.quoteToken = { ...state.quoteToken, ...payload }
    })
    .addCase(updateSwapDisabled, (state, { payload }) => {
      state.swapDisabled = payload
    })
    .addCase(updateCurrentConvertInfo, (state, { payload }) => {
      state.currentConvertInfo = {
        ...state.currentConvertInfo,
        ...cloneDeep(payload),
      }
    })
    .addCase(resertConvertState, (state) => {
      state.baseToken = initialState.baseToken
      state.quoteToken = initialState.quoteToken
      state.currentConvertInfo = initialState.currentConvertInfo
    })
})
